module.exports = __webpack_public_path__ + "resources/menu-0c8d2d6050cfe4c5b5cee8fed2bdee1a.svg";